import SignIn from 'src/app/preAuth/signin'
import SignIn2 from 'src/app/preAuth2/signin2'
import SuperAdminSetup from 'src/app/preAuth2/setup'
import DashboardRoutes from 'src/app/dashboard/dashboard-routing'
import DashboardV2Routes from 'src/app/dashboardv2/dashboard-routing'

export default [
    SignIn,
    SignIn2,
    SuperAdminSetup,
    DashboardRoutes,
    DashboardV2Routes,
]